<template>
    <div ref="diagram" id="sankey-diagram">

    </div>
</template>

<script>

import api from './Util/api'

import sankey from './sankey';
import sankeyTestTypes from './Util/TestData/sankey-test-types';
import sankeyTestData from './Util/TestData/sankey-test-data';

import resourceMixin from "../../../../../Util/Mixins/resources";

export default {
    name: 'sankey-diagram',
    mixins: [resourceMixin],
    created() {
        if(this.endpoint) {
            api.getDataFromEndpoint(this.endpoint).then(
                (response) =>{
                    this.apiData = response.data;
                    this.apiTypes = response.types;
                    this.apiReady = true;
                },
                (error) => {
                    this.apiReady = true;
                }
            )
        } else {
            this.apiReady = true;
        }
    },
    mounted() {
        const vm = this;
        
        const diagram = vm.$refs.diagram;
        
        diagram.addEventListener('nodeClick', e => vm.$emit('nodeClick', e));
        
        this.diagramMounted = true;
    },
    methods: {
        loadDiagram() {
            const vm = this;
            const diagram = vm.$refs.diagram;
            
            const diagramSelector = `#${diagram.id}`;
            
            //Reset our diagram in case of a previous diagram
            const range = document.createRange();
            range.selectNodeContents(document.querySelector(diagramSelector));
            range.deleteContents();
            
            sankey.initGraph(vm.myTypes, vm.myData);
            sankey.render(diagramSelector);
            
            this.loaded = true;
        }
    },
    watch: {
        apiReady() {
            if(this.isReady && !this.loaded) {
                this.loadDiagram();
            }
        },
        diagramMounted() {
            if(this.isReady && !this.loaded) {
                this.loadDiagram();
            }
        },
        myData(){
            if(this.isReady){
                this.loadDiagram();   
            }
        }
    },
    computed: {
        myData(){
            return this.apiData || this.data;
        },
        myTypes(){
            return this.apiTypes || this.types;
        },
        isReady(){
            return this.myData.length !== 0 && 
                this.diagramMounted && 
                this.apiReady;
        }
    },
    data() {
        return {
            apiData: null,
            apiTypes: null,
            apiReady: false,
            diagramMounted: false,
            loaded: false
        }
    },
    props: {
        types: {
            type: Array,
            default: () => {
                return sankeyTestTypes;
            }
        },
        data: {
            type: Array,
            default: () => {
                return sankeyTestData;
            }
        },
        endpoint: {
            type: String,
            default: null
        }
    }
};
</script>

<style lang="scss" scoped src="./Style/sankey.scss">
</style>
